export default __webpack_public_path__ + "static/media/09-nonprofit_thumb.6f726101.jpg";